import classNames from 'classnames';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IChoiceQuestionProp, IListItemOption } from '@/utils/ctype';
import i18n from '@/locales/init';
import Check from '../../../components/Check';
import Analysis from '../../../components/Analysis';
import SpeechBtn from '../../../components/SpeechBtn';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';

/**
 * 选择题
 * @param props 
 * @returns 
 */
export default function choiceQuestion(props: IChoiceQuestionProp & {index: number;isJudge?: boolean; className?: string;}) {
  const { data, groupId, currentFocus, saveAnswerHandle, type, answerMap, isAI, className, isJudge = false, isListen, keyIndex, index: itemIndex, answerAllText, setFocusIndexHandle} = props;
  const { title, number} = data;
  const {id} = data;
  const answerData = answerMap[`${groupId}_${type}_${id}`];
  const answerTitle = data.display_answer.split(',');
  const createAIType = (idStr: string, option: IListItemOption) => {
    if (!isAI) {
      return null;
    }

    const isCorrectAnswer = (!!option?.title && answerTitle.includes(option.title))
      || !!(isJudge && option?.content && answerTitle.includes(option.content));
    const isSelected = !!answerData && answerData.includes(idStr);

    if (isCorrectAnswer && isSelected) {
      return 'success';
    }
    if (!isCorrectAnswer && isSelected) {
      return 'fail';
    }
    if (isCorrectAnswer) {
      return 'missed';
    }
    return 'normal';
  };

  const getAIStatusText = (type?: string | null) => {
    switch (type) {
      case 'success':
        return i18n.t('common.dauyan_selected_correct');
      case 'fail':
        return i18n.t('common.dauyan_selected_wrong');
      case 'missed':
        return i18n.t('common.dauyan_missed_correct');
      default:
        return '';
    }
  };
  const handleChange = (ns: string) => {
    const s = answerData ? [...answerData] : [];
    saveAnswerHandle(number, {group_id: groupId, id: data.id, type: type, answer: s.includes(ns) ? s.filter((ss) => ss !== ns) : [...s, ns] });
  };

  return (
    <div className={classNames(`${style.questionBox}`, currentFocus === number ? style.active : '', className, `question${number}`, 'choiceQuestion')} id={`question${number}`}>
      <div className={style.questionContent} >
        <span className={classNames(style.questionNumber, currentFocus === number ? style.focus : '')} data-key={`$question.question.${keyIndex}.list.${itemIndex}.number`}><HtmlParser htmlString={data.numberHtml || String(number)}></HtmlParser></span>
        <span className={style.questionText} data-key={`question.question.${keyIndex}.list.${itemIndex}.title`}><HtmlParser htmlString={title}></HtmlParser></span>
        {isAI ? <span className={style.answerText} data-key={`answerAllText.${number-1}`}><HtmlParser htmlString={answerAllText[number - 1] || `(${i18n.t('common.dauyan_no_answer')})`}></HtmlParser></span> : null }
        {isAI && isListen ? <SpeechBtn onClick={() => {playAudio(data);}} index={number}></SpeechBtn> : null}
        {isAI ? <Analysis onClick={() => {parsingAI(data);}}></Analysis> : null}
      </div>
      <div className={style.answerBox}>
        {data.option.map((item, index: number) => {
          const idStr = String(item.id);
          const radioType = createAIType(idStr, item);
          const statusText = getAIStatusText(radioType);
          return (
            <div className={classNames(style.answer, radioType ? style[radioType]: '')} key={index}>
              <label data-key={`$question.question.${keyIndex}.list.${itemIndex}.option.${index}.content`}>
                <Check type={radioType} className={style.radio} name={`anwer${number}`} checked={answerData ? answerData.includes(idStr) : false}
                  onChange={() => {
                    handleChange(idStr);
                    // saveAnswerHandle(number, {group_id: groupId, id: data.id, type: type, answer: [idStr] });
                  }}
                  onFocus={() => { if (setFocusIndexHandle) {setFocusIndexHandle(number);}}}/>
                <HtmlParser htmlString={item.contentHtml || item.content}></HtmlParser>
                {statusText ? <span className={classNames(style.statusText, radioType ? style[`${radioType}Text`] : '')}>{statusText}</span> : null}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
